import { render } from "./mattermost.vue?vue&type=template&id=7cd77150&scoped=true&ts=true"
import script from "./mattermost.vue?vue&type=script&lang=ts"
export * from "./mattermost.vue?vue&type=script&lang=ts"

import "./mattermost.vue?vue&type=style&index=0&id=7cd77150&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd77150"]])

export default __exports__